import { defineComponent as _defineComponent } from 'vue'
import BaseList from "@/components-UI/list/BaseList.vue";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import { translateEUAccountStatsStatus } from "@/utils/translate";
import BaseChip from "@/components-UI/BaseChip.vue";
import ViewDateTime from "@/components/base/ViewDateTime.vue";
import BaseStatus from "@/components-UI/BaseStatus.vue";
import { useEUAccountsStore } from "@/store_v3/EUAccountsStore";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'ComponentHeader',
  setup(__props) {

const EUAccountsStore = useEUAccountsStore();
const {
    EUAccountObj,
} = storeToRefs(EUAccountsStore);


return { __sfc: true,EUAccountsStore, EUAccountObj, BaseList, BaseListItem, translateEUAccountStatsStatus, BaseChip, ViewDateTime, BaseStatus }
}

})